import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

// withFocusDrawerControls is a HOC used to wrap a component
// it adds props to the component which is used in tandem with
// `addFocusDrawerControls` to manipulate the focus drawer
const withFocusDrawerControls = (Component) =>
    (class WithFocusDrawerControlsWrapper extends PureComponent {
        static contextTypes = {
            showFocusDrawer: PropTypes.func,
            closeFocusDrawer: PropTypes.func,
            showFocusDrawerBottomBar: PropTypes.func,
            closeFocusDrawerBottomBar: PropTypes.func,
            addFocusDrawerNotification: PropTypes.func,
            hideFocusDrawerNotification: PropTypes.func,
        };

        // Read functions out of context and add it as a prop to the component
        render() {
            const {
                showFocusDrawer,
                closeFocusDrawer,
                showFocusDrawerBottomBar,
                closeFocusDrawerBottomBar,
                addFocusDrawerNotification,
                hideFocusDrawerNotification,
            } = this.context;

            return (
                <Component
                    showFocusDrawer={showFocusDrawer}
                    closeFocusDrawer={closeFocusDrawer}
                    showFocusDrawerBottomBar={showFocusDrawerBottomBar}
                    closeFocusDrawerBottomBar={closeFocusDrawerBottomBar}
                    addFocusDrawerNotification={addFocusDrawerNotification}
                    hideFocusDrawerNotification={hideFocusDrawerNotification}
                    {...this.props}
                />
            );
        }
    });

export default withFocusDrawerControls;
